import i18next from 'i18next';

// Mapa acao->chaves i18next. A chave 'ajudaInfotmaticaHtml' tem typo de proposito
// (espelha a chave no .resx) — nao "corrigir".
function obterTextoAjuda(acao) {
    const mapa = {
        dadosPessoais: { titulo: i18next.t('ajudaDadosPessoaisTitulo'), html: i18next.t('ajudaDadosPessoaisHtml') },
        redesSociais: { titulo: i18next.t('ajudaSocialTitulo'), html: i18next.t('ajudaSocialHtml') },
        deficiencia: { titulo: i18next.t('ajudaDeficienciaTitulo'), html: i18next.t('ajudaDeficienciaHtml') },
        objetivo: { titulo: i18next.t('ajudaObjetivoTitulo'), html: i18next.t('ajudaObjetivoHtml') },
        sintese: { titulo: i18next.t('ajudaSinteseTitulo'), html: i18next.t('ajudaSinteseHtml') },
        sinteseAprendiz: { titulo: i18next.t('ajudaAprendizTitulo'), html: i18next.t('ajudaAprendizHtml') },
        sinteseEstagio: { titulo: i18next.t('ajudaEstagioTitulo'), html: i18next.t('ajudaEstagioHtml') },
        formacao: { titulo: i18next.t('ajudaFormacaoTitulo'), html: i18next.t('ajudaFormacaoHtml') },
        experiencia: { titulo: i18next.t('ajudaExperienciaTitulo'), html: i18next.t('ajudaExperienciaHtml') },
        cursos: { titulo: i18next.t('ajudaCursoTitulo'), html: i18next.t('ajudaCursoHtml') },
        idiomas: { titulo: i18next.t('ajudaIdiomaTitulo'), html: i18next.t('ajudaIdiomaHtml') },
        informatica: { titulo: i18next.t('ajudaInformaticaTitulo'), html: i18next.t('ajudaInfotmaticaHtml') },
        complementar: { titulo: i18next.t('ajudaComplementarTitulo'), html: i18next.t('ajudaComplementarHtml') },
        diversidade: { titulo: i18next.t('ajudaDiversidadeTitulo'), html: i18next.t('ajudaDiversidadeHtml') },
    };
    return mapa[acao] || { titulo: '', html: '' };
}

export const janelaAjuda = function (element) {
    "use strict";
    var $modalAjuda = body.find('#modal-ajuda');
    var $modalBody = $modalAjuda.find('.modal-body');

    var _abrir = function (acao) {
        var texto = obterTextoAjuda(acao);
        var html = [];
        html.push('<h3 class="text-center">' + texto.titulo + '</h3>');
        html.push(texto.html);

        $modalBody.html(html.join(''));

        $modalAjuda.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
            $modalBody.html('');
            e.preventDefault();
        });

        $modalAjuda.modal();
    };

    var init = function () {
        element.find('.link-ajuda').on('click', function () {
            _abrir($(this).attr('data-acao'));
        });
    };

    return init();
};
